// import { transformUrlProxy, SLD } from '@patsnap-utils/biz';
import { readOverride } from '@eureka/shared/src/utils/local-backend-override';

export const EUREKA_SERVICE_URI = import.meta.env.VITE_EUREKA_SERVICE_URI;
export const CHEMICAL_GATEWAY_URI = import.meta.env.VITE_CHEMICAL_GATEWAY_URI;
export const ANALYTICS_URI = import.meta.env.VITE_ANALYTICS_URI;
export const ACCOUNT_SERVICE_URI = import.meta.env.VITE_ACCOUNT_SERVICE_URI;
export const CORE_SEARCH_SERVICE_URI = import.meta.env.VITE_CORE_SEARCH_SERVICE_URI;

export const EUREKA_URI = import.meta.env.VITE_EUREKA_URI;
export const DRAFTING_FE_BASE_URL = `${EUREKA_URI}/ip/drafting`;

// 本地后端切换器：dev 模式下允许通过浮层 UI 临时覆盖 drafting 后端地址。
// 覆盖值由 vite-plugins/local-backend-switcher 写入 localStorage：
//   - 本地后端：裸 URL，DRAFTING_URI 直接用它。
// qa/stage 环境选择由插件修改 .env.development 的 devEnv，Vite 重启后整套 env 一致生效。
// 仅 import.meta.env.DEV 生效；生产构建里 readOverride() 恒返回 null。
//
// 返回 [draftingUri, freeDraftingUri]
function resolveDraftingUris(): [string, string] {
    const override = import.meta.env.DEV ? readOverride() : null;

    if (override?.kind === 'local') {
        return [override.url, override.url];
    }

    // 无本地覆盖：回退当前 devEnv 对应的远程后端。
    return [`${EUREKA_SERVICE_URI}/drafting`, `${EUREKA_SERVICE_URI}/free/drafting`];
}

const [DRAFTING_URI_RESOLVED, FREE_DRAFTING_URI_RESOLVED] = resolveDraftingUris();

export const DRAFTING_URI = DRAFTING_URI_RESOLVED;

export const FREE_DRAFTING_URI = FREE_DRAFTING_URI_RESOLVED;


// User Service for payment functionality (拼接路径)
export const USER_SERVICE_URI = `${ACCOUNT_SERVICE_URI}/user-service`;

// export const PASSPORT_URI = transformUrlProxy(SLD.PASSPORT, import.meta.env.VITE_PASSPORT_URI);
// export const CORE_BASIC_SERVICE_URI = import.meta.env.VITE_CORE_BASIC_SERVICE_URI;
// export const STATIC_COMMON_URL = import.meta.env.VITE_STATIC_COMMON_URL;
// export const WORKSPACE_URI = import.meta.env.VITE_WORKSPACE_URI;
// export const WORKSPACE_SERVICE_URI = import.meta.env.VITE_WORKSPACE_SERVICE_URI;
